// extracted by mini-css-extract-plugin
export var content = "_p8-1";
export var fullScreen = "_p8-0";